/* import __COLOCATED_TEMPLATE__ from './materials.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { restartableTask, timeout } from 'ember-concurrency';
import { cleanQuery } from 'ilios-common/utils/query-utils';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { TrackedAsyncData } from 'ember-async-data';
const DEBOUNCE_DELAY = 250;
let CourseMaterialsComponent = (_class = class CourseMaterialsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dataLoader", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "courseQuery", _descriptor3, this);
    _initializerDefineProperty(this, "sessionQuery", _descriptor4, this);
    _defineProperty(this, "typesWithUrl", ['file', 'link']);
    _defineProperty(this, "setCourseQuery", _buildTask(() => ({
      context: this,
      generator: function* (q) {
        yield timeout(DEBOUNCE_DELAY);
        this.courseQuery = q;
      }
    }), null, "setCourseQuery", "restartable"));
    _defineProperty(this, "setSessionQuery", _buildTask(() => ({
      context: this,
      generator: function* (q) {
        yield timeout(DEBOUNCE_DELAY);
        this.sessionQuery = q;
      }
    }), null, "setSessionQuery", "restartable"));
  }
  get courseMaterialsData() {
    return new TrackedAsyncData(this.args.course.learningMaterials);
  }
  get courseSessionsData() {
    return new TrackedAsyncData(this.dataLoader.loadCourseSessions(this.args.course.id));
  }
  get sessionMaterialsData() {
    if (!this.courseSessionsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this.courseSessionsData.value.map(s => s.learningMaterials)));
  }
  get sessionMaterialLmsData() {
    if (!this.sessionMaterialsData?.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this.sessionMaterialsData.value.flat().map(s => s.learningMaterial)));
  }
  get courseMaterialLmsData() {
    if (!this.courseMaterialsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this.courseMaterialsData.value.map(c => c.learningMaterial)));
  }

  /**
   * Resolve session and LMs, so they can be used synchronous
   * in the filter.
   */
  get sessionMaterialObjects() {
    if (!this.sessionMaterialsData?.isResolved || !this.sessionMaterialLmsData?.isResolved) {
      return null;
    }
    return this.sessionMaterialsData.value.flat().map(slm => {
      const lm = this.store.peekRecord('learning-material', slm.belongsTo('learningMaterial').id());
      const session = this.store.peekRecord('session', slm.belongsTo('session').id());
      return {
        session,
        lm
      };
    });
  }
  get isLoading() {
    return !this.courseMaterialLmsData?.isResolved || !this.sessionMaterialLmsData?.isResolved;
  }
  get filteredCourseLearningMaterials() {
    if (!this.courseMaterialLmsData?.isResolved) {
      return [];
    }
    const q = cleanQuery(this.courseQuery);
    if (!q) {
      return this.courseMaterialLmsData.value;
    }
    const exp = new RegExp(q, 'gi');
    return this.courseMaterialLmsData.value.filter(obj => {
      return obj.title && obj.title.match(exp) || obj.description && obj.description.match(exp) || obj.originalAuthor && obj.originalAuthor.match(exp) || obj.type && obj.type.match(exp) || obj.citation && obj.citation.match(exp);
    });
  }
  get filteredSessionLearningMaterialObjects() {
    if (!this.sessionMaterialObjects) {
      return [];
    }
    const q = cleanQuery(this.sessionQuery);
    if (!q) {
      return this.sessionMaterialObjects;
    }
    const exp = new RegExp(q, 'gi');
    return this.sessionMaterialObjects.filter(obj => {
      return obj.lm.title && obj.lm.title.match(exp) || obj.lm.description && obj.lm.description.match(exp) || obj.lm.originalAuthor && obj.lm.originalAuthor.match(exp) || obj.lm.type && obj.lm.type.match(exp) || obj.lm.citation && obj.lm.citation.match(exp) || obj.session.title && obj.session.title.match(exp);
    });
  }
  get clmSortedAscending() {
    return this.args.courseSort.search(/desc/) === -1;
  }
  get slmSortedAscending() {
    return this.args.sessionSort.search(/desc/) === -1;
  }
  courseSortBy(prop) {
    if (this.args.courseSort === prop) {
      prop += ':desc';
    }
    this.args.onCourseSort(prop);
  }
  sessionSortBy(prop) {
    if (this.args.sessionSort === prop) {
      prop += ':desc';
    }
    this.args.onSessionSort(prop);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataLoader", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "courseQuery", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sessionQuery", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "courseMaterialsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseMaterialsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionMaterialsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionMaterialsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionMaterialLmsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionMaterialLmsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseMaterialLmsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseMaterialLmsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseSortBy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "courseSortBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionSortBy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sessionSortBy"), _class.prototype), _class);
export { CourseMaterialsComponent as default };